<template>
  <div class="header bg-gradient-primary border-radius-gradient pb-12 pt-2 pt-md-8">
    <nav class="navbar navbar-main navbar-expand-lg navbar-dark navbar-border" id="navbar-main">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbar-main-collapse"
        aria-controls="navbar-main-collapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >

        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse navbar-collapse-fade collapse" id="navbar-main-collapse">

        <ul class="navbar-nav align-items-lg-center">
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              href="#"
              role="button"
              aria-haspopup="true"
              aria-expanded="true"
            >INSS Cooperado</a>

            <div class="dropdown-menu">
              <a class="dropdown-item" href="#" @click="cadastroRedirect()">Cadastro</a>
              <a class="dropdown-item" href="#" @click="listaRedirect()">Lista</a>
              <a class="dropdown-item" href="#" @click="graficoRedirect()">Gráfico</a>
            </div>
          </li>
        </ul>
        <ul class="navbar-nav align-items-lg-center">
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              href="#"
              role="button"
              aria-haspopup="true"
              aria-expanded="true">Licença Previdenciária</a>
            <div class="dropdown-menu">
              <a class="dropdown-item" href="#" @click="cadastroLicencaRedirect()">Cadastro</a>
              <a class="dropdown-item" href="#" @click="listaLicencaRedirect()">Lista</a>
            </div>
          </li>
        </ul>
        
        <ul class="navbar-nav align-items-lg-center" v-show="habilitaLinkUteis">
          <li class="nav-item">
            <a
              class="nav-link"
              href="#" @click="listaLinkUteisRedirect()">Links Úteis</a>
          </li>
        </ul>
      </div>

      <div class="navbar-brand">
        <button type="button" class="btn btn-primary btn-contador-regressivo">
          Sessão :
          <span
            class="badge badge-pill"
            :class="classContadorRegressivo"
          >{{inputContadorRegressivo}}</span>
          <span class="sr-only">00:00</span>
        </button>
      </div>
      <div class="navbar-brand">
        <a
          class="nav-link pr-lg-0"
          href="#"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <div class="media media-pill align-items-center">
            <span class="btn-avatar rounded-circle btn-white">
              <i class="oi oi-person"></i>
            </span>
            <div class="ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold">{{nomeUsuario}}</span>
            </div>
          </div>
        </a>
        <div class="dropdown-menu dropdown-menu-sm dropdown-menu-right dropdown-menu-arrow">
          <a href="#" @click="termoResponsabilidade()" class="dropdown-item">
            <i class="far fa-sign-out-alt"></i>
            <span>Termo Responsabilidade</span>
          </a>
          <a href="#" @click="logout()" class="dropdown-item">
            <i class="far fa-sign-out-alt"></i>
            <span>Sair</span>
          </a>
        </div>
        
      </div>
    </nav>
  </div>
</template>

<script>
import moment from "moment";
moment.locale("pt-BR");
export default {
  name: "Nav",
  data() {
    return {
      nomeUsuario: this.$cooperadowebapi.tokens.get("usuario").nome,
      habilitaLinkUteis: this.$cooperadowebapi.tokens.get("usuario").link_uteis,
      inputContadorRegressivo: "00:00",
      classContadorRegressivo: "badge-light",
    };
  },
  created: function () {
    this.contadorRegressivo();
  },
  methods: {
    contadorRegressivo: function () {
      setInterval(() => {
        var expiresIn =
          this.$cooperadowebapi.tokens != undefined &&
          this.$cooperadowebapi.tokens.get("usuario") != undefined &&
          this.$cooperadowebapi.tokens.get("usuario").expiresIn != undefined
            ? this.$cooperadowebapi.tokens.get("usuario").expiresIn
            : undefined;
        if (expiresIn != undefined) {
          var x = new moment();
          var y = new moment(
            this.$cooperadowebapi.tokens.get("usuario").expiresIn
          );
          var duration = moment.duration(y.diff(x));
          //this.input.data = this.input.data.clone().subtract(1, 'seconds')
          if (parseInt(duration.get("minutes")) < 2) {
            if (parseInt(duration.get("seconds")) < 0) {
              this.classContadorRegressivo = "badge-danger";
            } else {
              if (this.classContadorRegressivo == "badge-danger") {
                this.classContadorRegressivo = "badge-light";
              } else {
                this.classContadorRegressivo = "badge-danger";
              }
            }
          } else {
            if (parseInt(duration.get("minutes")) < 5) {
              this.classContadorRegressivo = "badge-warning";
            } else {
              this.classContadorRegressivo = "badge-light";
            }
          }
          this.inputContadorRegressivo =
            (parseInt(duration.get("minutes")) > -1 &&
            parseInt(duration.get("minutes")) < 10
              ? "0" + duration.get("minutes")
              : parseInt(duration.get("minutes")) > -1
              ? duration.get("minutes")
              : "00") +
            ":" +
            (parseInt(duration.get("seconds")) > -1 &&
            parseInt(duration.get("seconds")) < 10
              ? "0" + duration.get("seconds")
              : parseInt(duration.get("seconds")) > -1
              ? duration.get("seconds")
              : "00");
        }
      }, 1000);
    },
    listaRedirect: function () {
      this.$router.push("/DeclaracaoInssLista");
    },
    cadastroRedirect: function () {
      this.$router.push("/DeclaracaoInssCadastro");
    },
    graficoRedirect: function () {
      this.$router.push("/DeclaracaoInssGrafico");
    },
    listaLicencaRedirect: function () {
      this.$router.push("/LicencaPrevidenciariaLista");
    },
    cadastroLicencaRedirect: function () {
      this.$router.push("/LicencaPrevidenciariaCadastro");
    },
    graficoRepasseRedirect: function () {
      this.$router.push("/DemonstrativoRepasseGrafico");
    },
    listaLinkUteisRedirect : function () {
      this.$router.push("/LinkUteisLista");
    },
    logout: function () {
      this.removerToken();
      this.$router.push("/");
    },
    termoResponsabilidade: function () {
      this.$router.push("/TermoResponsabilidadeLista");
    },
    removerToken: function () {
      this.$cooperadowebapi.tokens.delete("usuario");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Nav.vue